let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hHAog")).then(() => parcelRequire('14MtF'));